/**
 * Хто на тому кінці чату — рівно стільки, скільки треба, щоб його назвати.
 *
 * Чат належить картці (`student`) або лише контакту — Telegram-акаунту, якого
 * бот не впізнав (`contact`, а `student` тоді `null`). Картки в такої людини
 * немає: ні ПІБ, ні аватара, ні куди вести посилання.
 */
export interface ChatCounterpartSource {
  student?: { fullName: string } | null;
  contact?: { fullName?: string | null; username?: string | null } | null;
}

/** Коли Telegram не дав ні імені, ні тегу — а таке буває. */
export const GUEST_FALLBACK_NAME = 'Гість із Telegram';

/**
 * Гостьовий чат — чат без картки. Саме так, а не за статусом користувача:
 * гостя в `users` немає взагалі.
 */
export const isGuestChat = (chat: { student?: unknown }): boolean => !chat.student;

/**
 * Ім'я для списку, шапки, заголовка вкладки й сповіщень.
 *
 * Одна функція на всі місця: інакше гість у списку звався б «@olena», у шапці
 * — «Гість», а в сповіщенні — «студент», і секретар шукав би трьох людей.
 */
export const resolveChatCounterpartName = (chat: ChatCounterpartSource): string => {
  if (chat.student) {
    return chat.student.fullName;
  }

  const name = chat.contact?.fullName?.trim();

  if (name) {
    return name;
  }

  const username = chat.contact?.username?.trim();

  return username ? `@${username}` : GUEST_FALLBACK_NAME;
};
